import { DateTimeViewer, GetDefaultIndexWithCollect } from "../../components";
import {
  useCollectGlanceAdjustmentMarksMutation,
  useGetGlanceAdjustmentMarkCommonInfoQuery,
} from "../../features/board/glanceApi";
import { useGlanceAdjustmentMarkRoutes } from "./routes";
import { GlanceAdjustmentMarkCollector } from "./glanceAdjustmentMarkCollector";
import { Descriptions } from "antd";
import { EntityCommonInfoModel } from "../../entities/common";

export { useGlanceAdjustmentMarkRoutes };

export default GetDefaultIndexWithCollect({
  title: "مارک‌های تعدیل",
  query: useGetGlanceAdjustmentMarkCommonInfoQuery,
  collectMutation: useCollectGlanceAdjustmentMarksMutation,
  collector: (collectCallback) => <GlanceAdjustmentMarkCollector collectCallback={collectCallback} />,
  generalInfoPresentor: (info: EntityCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین کالکت" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastUpdateAt} mode="distance" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
